import React, { useState, useEffect } from 'react';
import EditForm from '../../components/Contacts/Page/EditForm';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import useApiManager from '../../utils/Api/apiManager';
import { useParams } from 'react-router-dom';

const EditContact = () => {
    const [leadOwnerOptions, setLeadOwnerOptions] = useState([{ label: '', value: '' }]);
    const [leadData, setLeadData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { get, put } = useApiManager();
    const { leadId } = useParams();

    const fetchLeadOwnerOptions = async () => {
        try {
            const data = await get('/users');
            // Assuming data is an array of user objects and each object has a `name` and `id` field
            const options = data.map(user => ({
                label: user.firstName + ' ' + user.lastName,
                value: user.id
            }));

            setLeadOwnerOptions(options);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {

        }
    };

    const fetchLeadData = async () => {
        try {
            const data = await get(`/leads/${leadId}`);
            console.log(data);
            setLeadData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeadOwnerOptions();
        fetchLeadData();
        document.title = "Edit Contact - iLead CRM";
    }, []);

    const goBack = () => {
        navigate(-1); // -1 goes back in history, equivalent to history.goBack()
    };

    const handleFormSubmit = async (formData) => {
        //console.log('Form Submitted:', formData);
        // Handle form submission logic here (e.g., send data to an API)
        try {
            const responseData = await put(`/leads/${leadId}`, formData);
            console.log('Form Submitted Successfully:', responseData);
            goBack();
            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };

    return (
        <Box sx={{ p: 5 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <h3>Edit Contact</h3>
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <Button variant="outlined" onClick={() => goBack()}>Cancel</Button>

                        <Button variant="contained" type="submit" form="create-form">Save</Button>
                    </Box>
                </Box>
                <Divider aria-hidden="true" sx={{ borderWidth: "thin" }} />
                <EditForm leadData={leadData} onSubmit={handleFormSubmit} leadOwnerOptions={leadOwnerOptions} loading={loading} />
            </Paper >
        </Box>
    )
};

export default EditContact;
